// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 주렁맨 페이지 스타일 (dev-steps §S4)
 * — CouponRedeemPage 의 좌/우 분할 + 태블릿 가로(1280×800) 기준을 따릅니다.
 * — 클래스 접두사 \`zm-\` 로 전역 충돌을 피합니다(QRScanner.css 의 \`.qr-scanner-*\` 와 별개).
 * — 현장 스탭이 서서 조작하므로 버튼 최소 높이 48~56px 을 유지합니다.
 */

.zm-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  font-family: 'Noto Sans KR', sans-serif;
  background: #EEF9F5;
}

/* ───── 화면 전체 공통 헤더 ───── */
.zm-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  min-height: 68px;
  box-sizing: border-box;
  padding: 10px 18px;
  color: #fff;
  background: linear-gradient(110deg, #0D9F7F 0%, #16B88B 55%, #2CCF9D 100%);
  border-bottom: 3px solid #087D65;
  box-shadow: 0 2px 8px rgba(8, 125, 101, 0.2);
  position: relative;
  z-index: 5;
}

.zm-header-main {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.zm-header h1 {
  font-size: clamp(23px, 2.2vw, 30px);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.03em;
  margin: 0;
  white-space: nowrap;
  text-shadow: 0 2px 6px rgba(2, 80, 62, 0.2);
}

.zm-btn-back {
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.32);
  color: #fff;
  padding: 10px 18px;
  border-radius: 12px;
  font-size: 15px;
  cursor: pointer;
  min-height: 44px;
}

.zm-store-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 12px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  border-radius: 999px;
  background: rgba(5, 120, 91, 0.72);
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
  box-shadow: 0 2px 7px rgba(5, 94, 72, 0.2);
}

.zm-store-name::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #D1FAE5;
  box-shadow: 0 0 0 3px rgba(209, 250, 229, 0.2);
}

.zm-content {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

/* ───── 좌 패널 (45%) — 스캐너 ───── */
.zm-left {
  width: 45%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(160deg, #12A77D 0%, #25BC8F 48%, #55D3AB 100%);
  color: #fff;
  border-right: 4px solid #0E9371;
}

.zm-scanner-area {
  position: relative;
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.zm-scanner-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(0, 0, 0, 0.55);
  font-size: 20px;
  font-weight: 600;
}

.zm-scanner-overlay p {
  margin: 0;
}

.zm-scanner-paused {
  background: rgba(8, 111, 85, 0.74);
}

.zm-scanner-paused-sub {
  font-size: 15px;
  font-weight: 400;
  opacity: 0.85;
}

.zm-spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: zm-spin 0.8s linear infinite;
}

@keyframes zm-spin {
  to {
    transform: rotate(360deg);
  }
}

.zm-scan-guide {
  text-align: center;
  font-size: 17px;
  margin: 0 0 10px;
  opacity: 0.92;
}

.zm-scan-error {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 18px 18px;
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(220, 38, 38, 0.92);
  color: #fff;
  font-size: 17px;
  font-weight: 600;
}

.zm-scan-error-icon {
  font-size: 20px;
}

/* ───── 우 패널 (55%) — 회원 카드 + 수량 ───── */
.zm-right {
  width: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  padding: clamp(18px, 2.4vw, 30px);
  background: linear-gradient(135deg, #F1FCF8 0%, #E4F8F0 60%, #D2F2E5 100%);
  overflow-y: auto;
}

.zm-scanner-rescan {
  min-height: 46px;
  margin-top: 8px;
  padding: 0 20px;
  border: 1px solid rgba(255, 255, 255, 0.82);
  border-radius: 10px;
  background: #fff;
  color: #087D65;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
}

.zm-scanner-rescan:active {
  background: #E6F8F1;
}

.zm-idle-state {
  flex: 1 1;
  display: grid;
  grid-template-rows: clamp(145px, 22vh, 190px) auto auto;
  align-content: center;
  justify-items: center;
  row-gap: 10px;
  color: #475569;
  text-align: center;
}

.zm-idle-image {
  width: clamp(132px, 16vw, 180px);
  height: clamp(62px, 7.5vw, 84px);
  align-self: center;
  opacity: 0.9;
}

.zm-idle-image img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.zm-idle-title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border: 1px solid #A8D8C7;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.76);
  color: #245A4B;
  font-size: clamp(20px, 1.8vw, 24px);
  font-weight: 800;
}

.zm-idle-title::before {
  content: '';
  width: 8px;
  height: 8px;
  flex: none;
  border-radius: 50%;
  background: #16B88B;
}

.zm-idle-description {
  margin: 0;
  color: #6F8C82;
  font-size: clamp(14px, 1.25vw, 17px);
}

.zm-empty {
  text-align: center;
  color: #64748B;
}

.zm-empty-icon {
  font-size: 64px;
  margin-bottom: 12px;
}

.zm-empty-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 6px;
  color: #334155;
}

.zm-empty-sub {
  font-size: 15px;
  margin: 0;
}

.zm-member-card {
  background: #fff;
  border-radius: 18px;
  padding: 22px;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.1);
}

.zm-member-card--empty {
  border: 1px dashed #9FB8AE;
  box-shadow: none;
}

.zm-member-card--empty .zm-member-name,
.zm-member-card--empty .zm-member-balance-value,
.zm-member-card--empty .zm-member-balance-unit {
  color: #789087;
}

.zm-member-label {
  margin: 0 0 12px;
  color: #24463C;
  font-size: 19px;
  font-weight: 800;
}

.zm-member-identity {
  margin-bottom: 16px;
  padding: 10px 14px;
  border-left: 4px solid #16B88B;
  border-radius: 0 10px 10px 0;
  background: #F4FAF8;
}

.zm-member-name-label {
  display: block;
  margin-bottom: 2px;
  color: #6B827A;
  font-size: 13px;
  font-weight: 700;
}

.zm-member-name {
  font-size: clamp(36px, 3.2vw, 44px);
  font-weight: 800;
  line-height: 1.12;
  letter-spacing: -0.035em;
  color: #0F172A;
  margin: 0;
  word-break: break-all;
}

.zm-member-balance {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border-radius: 12px;
  border: 1px solid #B7E8D5;
  background: linear-gradient(135deg, #F0FDF8 0%, #DDF7EC 100%);
}

.zm-member-coin-image {
  width: 54px;
  height: 54px;
  flex: none;
  object-fit: contain;
}

.zm-member-balance-copy {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  white-space: nowrap;
}

.zm-member-balance-amount {
  display: flex;
  align-items: baseline;
  gap: 5px;
}

.zm-member-balance-label {
  margin-bottom: 1px;
  font-size: 14px;
  font-weight: 700;
  color: #047857;
}

.zm-member-balance-value {
  font-size: 34px;
  font-weight: 800;
  color: #047857;
}

.zm-member-balance-unit {
  font-size: 15px;
  color: #047857;
}

.zm-btn-rescan {
  width: 100%;
  margin-top: 14px;
  min-height: 48px;
  border: 1px solid #CBD5E1;
  border-radius: 12px;
  background: #F8FAFC;
  color: #475569;
  font-size: 16px;
  cursor: pointer;
}

.zm-amount-block {
  background: #fff;
  border-radius: 18px;
  padding: 22px;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.1);
}

.zm-amount-title {
  font-size: clamp(22px, 2vw, 27px);
  font-weight: 800;
  color: #173D33;
  margin: 0 0 3px;
}

.zm-amount-description {
  margin: 0 0 14px;
  color: #647B73;
  font-size: 14px;
}

.zm-amount-buttons {
  display: flex;
  gap: 12px;
}

.zm-btn-amount {
  flex: 1 1;
  min-height: 84px;
  border: 2px solid #16A34A;
  border-radius: 16px;
  background: #fff;
  color: #15803D;
  font-size: 30px;
  font-weight: 700;
  cursor: pointer;
}

.zm-btn-amount:active {
  background: #DCFCE7;
}

.zm-btn-amount > span {
  margin-left: 3px;
  font-size: 15px;
  font-weight: 700;
}

.zm-btn-amount:disabled {
  border-color: #CBD8D3;
  background: #F3F7F5;
  color: #94A39D;
  cursor: not-allowed;
}

.zm-btn-amount-custom {
  flex: 1.25 1;
  background: #087D65;
  color: #fff;
  font-size: 18px;
}

.zm-btn-amount-custom:active {
  background: #066650;
}

.zm-amount-hint {
  margin: 12px 0 0;
  font-size: 14px;
  color: #64748B;
}

/* ───── 모달 (직접입력 / 확인) ───── */
.zm-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.zm-modal {
  width: min(440px, 88vw);
  background: #fff;
  border-radius: 20px;
  padding: 26px;
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.3);
}

.zm-modal-title {
  font-size: 21px;
  font-weight: 700;
  color: #0F172A;
  margin: 0 0 18px;
}

.zm-modal-input {
  width: 100%;
  min-height: 62px;
  padding: 0 16px;
  font-size: 28px;
  text-align: center;
  border: 2px solid #CBD5E1;
  border-radius: 12px;
}

.zm-modal-input:focus {
  outline: none;
  border-color: #16A34A;
}

.zm-modal-error {
  margin: 12px 0 0;
  color: #DC2626;
  font-size: 16px;
  font-weight: 600;
}

.zm-modal-actions {
  display: flex;
  gap: 12px;
  margin-top: 22px;
}

.zm-btn-cancel,
.zm-btn-primary {
  flex: 1 1;
  min-height: 56px;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
}

.zm-btn-cancel {
  border: 1px solid #CBD5E1;
  background: #F8FAFC;
  color: #475569;
}

.zm-btn-primary {
  border: none;
  background: #16A34A;
  color: #fff;
}

.zm-btn-primary:disabled,
.zm-btn-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.zm-confirm-list {
  margin: 0;
}

.zm-confirm-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #E2E8F0;
}

.zm-confirm-row dt {
  font-size: 15px;
  color: #64748B;
}

.zm-confirm-row dd {
  margin: 0;
  font-size: 19px;
  font-weight: 600;
  color: #0F172A;
}

/* ⚠️ \`.zm-confirm-row dd\`(클래스1+요소1) 보다 명시도가 높아야 하므로 요소까지 붙입니다.
   \`.zm-confirm-amount\` 단독은 명시도가 낮아 색/크기가 먹지 않습니다(!important 대신 명시도로 해결). */
.zm-confirm-row dd.zm-confirm-amount {
  color: #15803D;
  font-size: 24px;
}

/* ───── 성공 토스트 ───── */
.zm-toast {
  position: fixed;
  left: 50%;
  bottom: 36px;
  transform: translateX(-50%);
  max-width: 90vw;
  padding: 16px 24px;
  border-radius: 14px;
  background: #15803D;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.28);
  z-index: 1100;
}

/* ───── 폰(세로로 긴 화면) 반응형 — 좌우 2단을 위/아래 스택으로 ───── */
/* 주렁맨은 폰(크롬 웹)에서 쓰는 일이 많다. 세로 화면에선:
   - 100vh 강제분할(overflow:hidden) 대신 "문서 흐름 + 세로 스크롤"로 바꿔 컴포넌트 겹침을 없앤다.
   - 스캐너(위) → 회원카드·수량(아래) 순서로 자연 스택.
   가로(태블릿)는 기존 좌우 2단 그대로 유지. */
@media (orientation: portrait) {
  .zm-page {
    height: auto;
    min-height: 100vh;
    overflow-y: auto;
  }
  .zm-content {
    flex-direction: column;
    overflow: visible;
  }
  .zm-left {
    width: 100%;
    flex: 0 0 auto;         /* 늘어나 겹치지 않게 — 콘텐츠 높이만큼 */
    border-right: none;
    border-bottom: 4px solid #0E9371;
  }
  .zm-right {
    width: 100%;
    flex: 0 0 auto;
    justify-content: flex-start;
    overflow: visible;      /* 내부 스크롤 대신 페이지 스크롤 사용 */
  }
  /* 스캐너 영역도 콘텐츠(정사각 뷰포트) 높이만큼만 차지 */
  .zm-scanner-area {
    flex: 0 0 auto;
  }
  /* 뷰포트: 폭·높이 둘 다 화면에 맞춘 정사각형(한쪽만 맞춰 넘쳐 겹치던 문제 해결) */
  .zm-page .qr-scanner-viewport {
    width: min(84vw, 46vh);
    height: auto;
    aspect-ratio: 1;
  }
}

@media (max-height: 650px) and (min-width: 761px) {
  .zm-idle-state {
    grid-template-rows: 132px auto auto;
    row-gap: 8px;
  }

  .zm-idle-image {
    width: 142px;
    height: 66px;
  }

  .zm-idle-title {
    font-size: 21px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ZoolungmanPage.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,0EAA0E;EAC1E,gCAAgC;EAChC,4CAA4C;EAC5C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,0EAA0E;EAC1E,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,iCAAiC;EACjC,0EAA0E;EAC1E,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uDAAuD;EACvD,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAU;EACV,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;2EAC2E;AAC3E;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,aAAa;AACf;;AAEA,mDAAmD;AACnD;;;8BAG8B;AAC9B;EACE;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,cAAc,UAAU,0BAA0B;IAClD,kBAAkB;IAClB,gCAAgC;EAClC;EACA;IACE,WAAW;IACX,cAAc;IACd,2BAA2B;IAC3B,iBAAiB,OAAO,yBAAyB;EACnD;EACA,kCAAkC;EAClC;IACE,cAAc;EAChB;EACA,mDAAmD;EACnD;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mCAAmC;IACnC,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/**\n * 주렁맨 페이지 스타일 (dev-steps §S4)\n * — CouponRedeemPage 의 좌/우 분할 + 태블릿 가로(1280×800) 기준을 따릅니다.\n * — 클래스 접두사 `zm-` 로 전역 충돌을 피합니다(QRScanner.css 의 `.qr-scanner-*` 와 별개).\n * — 현장 스탭이 서서 조작하므로 버튼 최소 높이 48~56px 을 유지합니다.\n */\n\n.zm-page {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n  font-family: 'Noto Sans KR', sans-serif;\n  background: #EEF9F5;\n}\n\n/* ───── 화면 전체 공통 헤더 ───── */\n.zm-header {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  min-height: 68px;\n  box-sizing: border-box;\n  padding: 10px 18px;\n  color: #fff;\n  background: linear-gradient(110deg, #0D9F7F 0%, #16B88B 55%, #2CCF9D 100%);\n  border-bottom: 3px solid #087D65;\n  box-shadow: 0 2px 8px rgba(8, 125, 101, 0.2);\n  position: relative;\n  z-index: 5;\n}\n\n.zm-header-main {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.zm-header h1 {\n  font-size: clamp(23px, 2.2vw, 30px);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.03em;\n  margin: 0;\n  white-space: nowrap;\n  text-shadow: 0 2px 6px rgba(2, 80, 62, 0.2);\n}\n\n.zm-btn-back {\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.32);\n  color: #fff;\n  padding: 10px 18px;\n  border-radius: 12px;\n  font-size: 15px;\n  cursor: pointer;\n  min-height: 44px;\n}\n\n.zm-store-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.75);\n  border-radius: 999px;\n  background: rgba(5, 120, 91, 0.72);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 800;\n  white-space: nowrap;\n  box-shadow: 0 2px 7px rgba(5, 94, 72, 0.2);\n}\n\n.zm-store-name::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #D1FAE5;\n  box-shadow: 0 0 0 3px rgba(209, 250, 229, 0.2);\n}\n\n.zm-content {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: row;\n  overflow: hidden;\n}\n\n/* ───── 좌 패널 (45%) — 스캐너 ───── */\n.zm-left {\n  width: 45%;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(160deg, #12A77D 0%, #25BC8F 48%, #55D3AB 100%);\n  color: #fff;\n  border-right: 4px solid #0E9371;\n}\n\n.zm-scanner-area {\n  position: relative;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n}\n\n.zm-scanner-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  background: rgba(0, 0, 0, 0.55);\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.zm-scanner-overlay p {\n  margin: 0;\n}\n\n.zm-scanner-paused {\n  background: rgba(8, 111, 85, 0.74);\n}\n\n.zm-scanner-paused-sub {\n  font-size: 15px;\n  font-weight: 400;\n  opacity: 0.85;\n}\n\n.zm-spinner {\n  width: 44px;\n  height: 44px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: zm-spin 0.8s linear infinite;\n}\n\n@keyframes zm-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.zm-scan-guide {\n  text-align: center;\n  font-size: 17px;\n  margin: 0 0 10px;\n  opacity: 0.92;\n}\n\n.zm-scan-error {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 18px 18px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  background: rgba(220, 38, 38, 0.92);\n  color: #fff;\n  font-size: 17px;\n  font-weight: 600;\n}\n\n.zm-scan-error-icon {\n  font-size: 20px;\n}\n\n/* ───── 우 패널 (55%) — 회원 카드 + 수량 ───── */\n.zm-right {\n  width: 55%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 20px;\n  padding: clamp(18px, 2.4vw, 30px);\n  background: linear-gradient(135deg, #F1FCF8 0%, #E4F8F0 60%, #D2F2E5 100%);\n  overflow-y: auto;\n}\n\n.zm-scanner-rescan {\n  min-height: 46px;\n  margin-top: 8px;\n  padding: 0 20px;\n  border: 1px solid rgba(255, 255, 255, 0.82);\n  border-radius: 10px;\n  background: #fff;\n  color: #087D65;\n  font-size: 16px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.zm-scanner-rescan:active {\n  background: #E6F8F1;\n}\n\n.zm-idle-state {\n  flex: 1;\n  display: grid;\n  grid-template-rows: clamp(145px, 22vh, 190px) auto auto;\n  align-content: center;\n  justify-items: center;\n  row-gap: 10px;\n  color: #475569;\n  text-align: center;\n}\n\n.zm-idle-image {\n  width: clamp(132px, 16vw, 180px);\n  height: clamp(62px, 7.5vw, 84px);\n  align-self: center;\n  opacity: 0.9;\n}\n\n.zm-idle-image img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.zm-idle-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 14px;\n  border: 1px solid #A8D8C7;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.76);\n  color: #245A4B;\n  font-size: clamp(20px, 1.8vw, 24px);\n  font-weight: 800;\n}\n\n.zm-idle-title::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  flex: none;\n  border-radius: 50%;\n  background: #16B88B;\n}\n\n.zm-idle-description {\n  margin: 0;\n  color: #6F8C82;\n  font-size: clamp(14px, 1.25vw, 17px);\n}\n\n.zm-empty {\n  text-align: center;\n  color: #64748B;\n}\n\n.zm-empty-icon {\n  font-size: 64px;\n  margin-bottom: 12px;\n}\n\n.zm-empty-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0 0 6px;\n  color: #334155;\n}\n\n.zm-empty-sub {\n  font-size: 15px;\n  margin: 0;\n}\n\n.zm-member-card {\n  background: #fff;\n  border-radius: 18px;\n  padding: 22px;\n  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.1);\n}\n\n.zm-member-card--empty {\n  border: 1px dashed #9FB8AE;\n  box-shadow: none;\n}\n\n.zm-member-card--empty .zm-member-name,\n.zm-member-card--empty .zm-member-balance-value,\n.zm-member-card--empty .zm-member-balance-unit {\n  color: #789087;\n}\n\n.zm-member-label {\n  margin: 0 0 12px;\n  color: #24463C;\n  font-size: 19px;\n  font-weight: 800;\n}\n\n.zm-member-identity {\n  margin-bottom: 16px;\n  padding: 10px 14px;\n  border-left: 4px solid #16B88B;\n  border-radius: 0 10px 10px 0;\n  background: #F4FAF8;\n}\n\n.zm-member-name-label {\n  display: block;\n  margin-bottom: 2px;\n  color: #6B827A;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.zm-member-name {\n  font-size: clamp(36px, 3.2vw, 44px);\n  font-weight: 800;\n  line-height: 1.12;\n  letter-spacing: -0.035em;\n  color: #0F172A;\n  margin: 0;\n  word-break: break-all;\n}\n\n.zm-member-balance {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 18px;\n  border-radius: 12px;\n  border: 1px solid #B7E8D5;\n  background: linear-gradient(135deg, #F0FDF8 0%, #DDF7EC 100%);\n}\n\n.zm-member-coin-image {\n  width: 54px;\n  height: 54px;\n  flex: none;\n  object-fit: contain;\n}\n\n.zm-member-balance-copy {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  white-space: nowrap;\n}\n\n.zm-member-balance-amount {\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n}\n\n.zm-member-balance-label {\n  margin-bottom: 1px;\n  font-size: 14px;\n  font-weight: 700;\n  color: #047857;\n}\n\n.zm-member-balance-value {\n  font-size: 34px;\n  font-weight: 800;\n  color: #047857;\n}\n\n.zm-member-balance-unit {\n  font-size: 15px;\n  color: #047857;\n}\n\n.zm-btn-rescan {\n  width: 100%;\n  margin-top: 14px;\n  min-height: 48px;\n  border: 1px solid #CBD5E1;\n  border-radius: 12px;\n  background: #F8FAFC;\n  color: #475569;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.zm-amount-block {\n  background: #fff;\n  border-radius: 18px;\n  padding: 22px;\n  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.1);\n}\n\n.zm-amount-title {\n  font-size: clamp(22px, 2vw, 27px);\n  font-weight: 800;\n  color: #173D33;\n  margin: 0 0 3px;\n}\n\n.zm-amount-description {\n  margin: 0 0 14px;\n  color: #647B73;\n  font-size: 14px;\n}\n\n.zm-amount-buttons {\n  display: flex;\n  gap: 12px;\n}\n\n.zm-btn-amount {\n  flex: 1;\n  min-height: 84px;\n  border: 2px solid #16A34A;\n  border-radius: 16px;\n  background: #fff;\n  color: #15803D;\n  font-size: 30px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.zm-btn-amount:active {\n  background: #DCFCE7;\n}\n\n.zm-btn-amount > span {\n  margin-left: 3px;\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.zm-btn-amount:disabled {\n  border-color: #CBD8D3;\n  background: #F3F7F5;\n  color: #94A39D;\n  cursor: not-allowed;\n}\n\n.zm-btn-amount-custom {\n  flex: 1.25;\n  background: #087D65;\n  color: #fff;\n  font-size: 18px;\n}\n\n.zm-btn-amount-custom:active {\n  background: #066650;\n}\n\n.zm-amount-hint {\n  margin: 12px 0 0;\n  font-size: 14px;\n  color: #64748B;\n}\n\n/* ───── 모달 (직접입력 / 확인) ───── */\n.zm-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.zm-modal {\n  width: min(440px, 88vw);\n  background: #fff;\n  border-radius: 20px;\n  padding: 26px;\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.3);\n}\n\n.zm-modal-title {\n  font-size: 21px;\n  font-weight: 700;\n  color: #0F172A;\n  margin: 0 0 18px;\n}\n\n.zm-modal-input {\n  width: 100%;\n  min-height: 62px;\n  padding: 0 16px;\n  font-size: 28px;\n  text-align: center;\n  border: 2px solid #CBD5E1;\n  border-radius: 12px;\n}\n\n.zm-modal-input:focus {\n  outline: none;\n  border-color: #16A34A;\n}\n\n.zm-modal-error {\n  margin: 12px 0 0;\n  color: #DC2626;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.zm-modal-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 22px;\n}\n\n.zm-btn-cancel,\n.zm-btn-primary {\n  flex: 1;\n  min-height: 56px;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.zm-btn-cancel {\n  border: 1px solid #CBD5E1;\n  background: #F8FAFC;\n  color: #475569;\n}\n\n.zm-btn-primary {\n  border: none;\n  background: #16A34A;\n  color: #fff;\n}\n\n.zm-btn-primary:disabled,\n.zm-btn-cancel:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.zm-confirm-list {\n  margin: 0;\n}\n\n.zm-confirm-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  padding: 12px 0;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.zm-confirm-row dt {\n  font-size: 15px;\n  color: #64748B;\n}\n\n.zm-confirm-row dd {\n  margin: 0;\n  font-size: 19px;\n  font-weight: 600;\n  color: #0F172A;\n}\n\n/* ⚠️ `.zm-confirm-row dd`(클래스1+요소1) 보다 명시도가 높아야 하므로 요소까지 붙입니다.\n   `.zm-confirm-amount` 단독은 명시도가 낮아 색/크기가 먹지 않습니다(!important 대신 명시도로 해결). */\n.zm-confirm-row dd.zm-confirm-amount {\n  color: #15803D;\n  font-size: 24px;\n}\n\n/* ───── 성공 토스트 ───── */\n.zm-toast {\n  position: fixed;\n  left: 50%;\n  bottom: 36px;\n  transform: translateX(-50%);\n  max-width: 90vw;\n  padding: 16px 24px;\n  border-radius: 14px;\n  background: #15803D;\n  color: #fff;\n  font-size: 18px;\n  font-weight: 600;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.28);\n  z-index: 1100;\n}\n\n/* ───── 폰(세로로 긴 화면) 반응형 — 좌우 2단을 위/아래 스택으로 ───── */\n/* 주렁맨은 폰(크롬 웹)에서 쓰는 일이 많다. 세로 화면에선:\n   - 100vh 강제분할(overflow:hidden) 대신 \"문서 흐름 + 세로 스크롤\"로 바꿔 컴포넌트 겹침을 없앤다.\n   - 스캐너(위) → 회원카드·수량(아래) 순서로 자연 스택.\n   가로(태블릿)는 기존 좌우 2단 그대로 유지. */\n@media (orientation: portrait) {\n  .zm-page {\n    height: auto;\n    min-height: 100vh;\n    overflow-y: auto;\n  }\n  .zm-content {\n    flex-direction: column;\n    overflow: visible;\n  }\n  .zm-left {\n    width: 100%;\n    flex: 0 0 auto;         /* 늘어나 겹치지 않게 — 콘텐츠 높이만큼 */\n    border-right: none;\n    border-bottom: 4px solid #0E9371;\n  }\n  .zm-right {\n    width: 100%;\n    flex: 0 0 auto;\n    justify-content: flex-start;\n    overflow: visible;      /* 내부 스크롤 대신 페이지 스크롤 사용 */\n  }\n  /* 스캐너 영역도 콘텐츠(정사각 뷰포트) 높이만큼만 차지 */\n  .zm-scanner-area {\n    flex: 0 0 auto;\n  }\n  /* 뷰포트: 폭·높이 둘 다 화면에 맞춘 정사각형(한쪽만 맞춰 넘쳐 겹치던 문제 해결) */\n  .zm-page .qr-scanner-viewport {\n    width: min(84vw, 46vh);\n    height: auto;\n    aspect-ratio: 1;\n  }\n}\n\n@media (max-height: 650px) and (min-width: 761px) {\n  .zm-idle-state {\n    grid-template-rows: 132px auto auto;\n    row-gap: 8px;\n  }\n\n  .zm-idle-image {\n    width: 142px;\n    height: 66px;\n  }\n\n  .zm-idle-title {\n    font-size: 21px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
